import { fileTypesEnum } from "kubb";
import { startCase } from "lodash-es";
import type React from "react";
import type { LabelProps } from "../../../../../components/Forms/NewLabelWrapper";
import {
  type Option,
  SelectComboField,
} from "../../../../../components/Forms/SelectCombo/SelectCombo";

export default function FileTypeSelect(props: {
  fieldName: string;
  label?: LabelProps;
}): React.ReactElement {
  const { fieldName, label, ...rest } = props;

  const options: Option[] = Object.values(fileTypesEnum).map(
    (v: string): Option => ({
      value: v,
      label: startCase(v.replace(/_/g, " ")),
    }),
  );

  return (
    <SelectComboField
      options={options}
      fieldName={fieldName}
      placeholder="All file types"
      label={label}
      clearable
      {...rest}
    />
  );
}
